<template>
  <ion-app>
    <ion-content>
      <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
      <ion-grid>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <div class="back-button-bg" @click="gotoBack">
          <ion-icon mode="ios" name="arrow-back" size="large" class="white"></ion-icon>
        </div>
        <p class="page-title">Alternativas</p>
        <div class="dropup-menu">
          <p class="mt-0 mb-0 text-sm ion-text-uppercase darkgrey">Refeição selecionada</p>
          <div class="meals mt-2">
            <div class="meal meal-selected pt-0 pb-0 mb-2">
              <ion-item lines="none" no-padding>
                <ion-avatar slot="start" class="meal-avatar">
                  <ion-img v-if="chosenDish.data.picture" :src="chosenDish.data.picture"></ion-img>
                  <ion-img
                    v-else
                    src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/dish_grey.svg?alt=media&token=a4cfabaa-54e0-458f-858b-507f74630d1c"
                  ></ion-img>
                </ion-avatar>
                <ion-label>
                  <p class="mt-0 mb-0 ion-text-uppercase grey text-xs">{{ chosenDish.data.meal }}</p>
                  <p class="mt-0 mb-0 dark text-sm bold ion-text-wrap">{{ chosenDish.data.namePT }}</p>
                </ion-label>
              </ion-item>
              <div class="meal-icon">
                <ion-icon mode="ios" name="checkmark-circle" color="primary"></ion-icon>
              </div>
            </div>
          </div>
          <p class="mt-4 mb-2 text-sm ion-text-uppercase darkgrey">Alternativas</p>
          <div v-if="alternatives.length > 0">
            <div v-for="alternative in alternatives" :key="alternative.id">
              <div class="meals mt-2">
                <div
                  class="meal pt-0 pb-0 mb-2 cursor-pointer"
                  @click="gotoAlternative(alternative)"
                >
                  <ion-item lines="none" no-padding>
                    <ion-avatar slot="start" class="meal-avatar">
                      <ion-img v-if="alternative.data.picture" :src="alternative.data.picture"></ion-img>
                      <ion-img
                        v-else
                        src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/dish_grey.svg?alt=media&token=a4cfabaa-54e0-458f-858b-507f74630d1c"
                      ></ion-img>
                    </ion-avatar>
                    <ion-label>
                      <p
                        class="mt-0 mb-0 ion-text-uppercase grey text-xs"
                      >{{ chosenDish.data.meal }}</p>
                      <p
                        class="mt-0 mb-0 dark text-sm bold ion-text-wrap"
                      >{{ alternative.data.namePT }}</p>
                    </ion-label>
                  </ion-item>
                  <ion-icon mode="ios" name="arrow-dropright-circle" color="primary"></ion-icon>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <p
              class="mt-4 text-sm grey"
            >Infelizmente não encontramos alternativas pra essa refeição :/</p>
          </div>
        </div>
      </ion-grid>
    </ion-content>
  </ion-app>
</template>

<script>
// firebase
import db from "@/firebase/init";
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// store
import store from "../../utils/store.js";
// utils
import { translateMeal } from "../../utils/formulas.js";
// component
export default {
  name: "AlternativeMeals",
  components: {
    Loading
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      isLoading: true,
      fullPage: true,
      user: store.state.user,
      chosenDish: {
        id: null,
        data: {
          meal: null,
          namePT: null
        }
      },
      alternatives: []
    };
  },
  methods: {
    clearNotification() {
      this.notification = {
        class: "error-message p-3 d-none",
        message: null
      };
    },
    gotoBack() {
      this.$router.go(-1);
    },
    gotoAlternative(alternative) {
      this.$router.push({
        name: "Alternative Meal",
        params: {
          mealplanId: this.$route.params.mealplanId,
          dishId: alternative.id,
          proportion: alternative.data.proportion
        }
      });
    }
  },
  async created() {
    const instance = this;
    await store.signinUser();
    instance.user = store.state.user;
    instance.profile = store.state.profile;
    try {
      // get mealplan data
      const mealplanId = this.$route.params.mealplanId;
      const mpRef = db.collection("mealplans").doc(mealplanId);
      const mpDoc = await mpRef.get();
      const mealplan = {
        id: mpDoc.id,
        data: mpDoc.data()
      };
      // get chosen dish data
      const dishId = mealplan.data.chosenDish.id;
      const dishRef = db.collection("dishes").doc(dishId);
      const doc = await dishRef.get();
      const data = doc.data();
      data.meal = translateMeal(mealplan.data.meal);
      instance.chosenDish = {
        id: doc.id,
        data: data
      };
      // get alternatives data
      const alternatives = mealplan.data.alternatives;
      let alt = [];
      for (let i = 0; i < alternatives.length; i++) {
        if (alternatives[i].id) {
          const altRef = db.collection("dishes").doc(alternatives[i].id);
          const doc = await altRef.get();
          const data = doc.data();
          data.proportion = alternatives[i].proportion;
          const altObj = {
            id: doc.id,
            data: data
          };
          alt.push(altObj);
        }
      }
      instance.alternatives = alt;
    } catch (e) {
      console.log(e);
      instance.isLoading = false;
    }
    this.isLoading = false;
  }
};
</script>

<style scoped>
ion-app {
  background: var(--bg-color-light) !important;
}
ion-content {
  --background: var(--ion-color-grey) !important;
}
ion-item {
  --padding-start: 10px;
}
.meal {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 70px !important;
  width: 100%;
  border-radius: 15px !important;
  background: white;
  box-shadow: 0 12px 6px -3px rgba(0, 0, 0, 0.15);
  padding-right: 10px;
}
.meal-avatar {
  height: 50px;
  width: 50px;
}
.meal-icon {
  width: 1.75rem !important;
}
.meal ion-icon {
  font-size: 1.75rem !important;
}
.meal-selected {
  border: 3px solid var(--ion-color-primary);
}
.dropup-menu {
  background: var(--bg-color-light) !important;
  padding-left: 5vw !important;
  padding-right: 5vw !important;
}
</style>
